export default "__VITE_ASSET__433b323e__"